export default __webpack_public_path__ + "static/media/grade_3_26_1@2x.de0641f2.png";